<div class="card-group">
    <div class="card pl-3 pr-3">
        <div class="card-body">
            <h5 class="card-text font-weight-bold mb-0">
                Ultimo folio ocupado:
                <span class="font-weight-normal" *ngIf="loading">Obteniendo folios...</span>
                <span class="font-weight-normal" *ngIf="!loading && !existFolios">No existen folios</span>
                <span class="font-weight-normal" *ngIf="!loading && existFolios">{{dataCaf?.ultimo_folio + contadorFacturas | numerico}}</span>
            </h5>
            <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
        </div>
    </div>
    <div class="card pl-3 pr-3">
        <div class="card-body">
            <h5 class="card-text font-weight-bold mb-0">Folios disponibles:
                <span class="font-weight-normal" *ngIf="loading">Obteniendo folios...</span>
                <span class="font-weight-normal" *ngIf="!loading && !existFolios">No existen folios</span>
                <span class="font-weight-normal" *ngIf="!loading && existFolios">{{dataCaf?.folios_disponibles - contadorFacturas | numerico}}</span>
            </h5>
            <!-- <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p> -->
        </div>
    </div>
    <!-- {{dataCaf | json}} -->
</div>
